<h2 mat-dialog-title>Azienda</h2>

<app-spinner-overlay></app-spinner-overlay>
<div mat-dialog-content class="dialog-center-cont">
  <mat-stepper labelPosition="end" #stepper>
    <mat-step [stepControl]="formAzienda" errorMessage="Campi obbligaotri mancanti">
      <ng-template matStepLabel>Dati Azienda</ng-template>
      <form [formGroup]="formAzienda" appFormContainer [larghezza]="6" style="padding-right: 10px">
        <div class="cnt-form-step1" appFormElement [larghezza]="4" [riempi]="true">
          @if (visualizzaUtente()) {
            <app-autocomplete
              appFormElement
              [larghezza]="2"
              [riempi]="true"
              formControlName="idUtente"
              [label]="'Utente'"
              [loadDataFn]="getUtentiAutoComplete"
              [displayFn]="displayFnUtente"
              [compare]="compareById"
              [required]="true"
              [chiaveId]="'id'"
              [spinnerLoading]="loadingUtente"
              [numeroRecOptions]="10"
              (recordChange)="changeSelectionUtente($event)"
            >
            </app-autocomplete>
          }

          <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
            <mat-label>Nome Impresa</mat-label>
            <input matInput placeholder="Nome Impresa" formControlName="ragioneSociale" />
            <mat-error appFormError></mat-error>
          </mat-form-field>

          <div
            appFormElement
            [larghezza]="4"
            [riempi]="true"
            style="display: flex; flex-direction: row; column-gap: 20px"
          >
            <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
              <mat-label>P.IVA</mat-label>
              <input
                matInput
                placeholder="P.IVA"
                formControlName="piva"
                minlength="11"
                maxlength="11"
              />
              <mat-error appFormError></mat-error>
            </mat-form-field>
          </div>

          @if (this.visualizzaCodiceAteco()) {
            <app-ateco-selector formControlName="codiciAteco" [required]="isAtecoRequired">
            </app-ateco-selector>
          }
        </div>

        <!-- Right column: logo upload -->
        <div class="logo-column">
          <div class="logo-upload-card">
            <div class="section-label">
              <mat-icon class="section-label__icon">image</mat-icon>
              <span>Logo Aziendale</span>
            </div>
            <div class="logo-preview-area">
              <div
                class="logo-preview"
                [ngClass]="
                  urlLogo || logoDaSalvare ? 'not-border-logo-preview' : 'border-logo-preview'
                "
                [ngStyle]="{
                  'background-image': 'url(' + (urlLogo ? urlLogo : imagePreview) + ')',
                }"
                [class.logo-preview--empty]="!urlLogo && !imagePreview"
              >
                @if (!urlLogo && !imagePreview) {
                  <div class="logo-empty-state">
                    <mat-icon class="logo-empty-state__icon">add_photo_alternate</mat-icon>
                    <span class="logo-empty-state__text">Nessun logo</span>
                  </div>
                }
                <div class="logo-overlay">
                  <mat-icon>edit</mat-icon>
                  <span>Cambia logo</span>
                </div>
              </div>
              <input
                [disabled]="this.isPermessoSoloRead"
                id="fileInput"
                type="file"
                (change)="fileSelezionato($any($event.target)?.files)"
                class="file-input-hidden"
                accept="image/*"
              />
            </div>

            <div class="logo-actions">
              @if (urlLogo || logoDaSalvare) {
                <button
                  [disabled]="this.isPermessoSoloRead"
                  class="logo-action-btn logo-action-btn--remove"
                  mat-stroked-button
                  (click)="eliminaLogo()"
                >
                  <mat-icon>delete_outline</mat-icon>
                  Rimuovi logo
                </button>
              }

              @if (!urlLogo && !logoDaSalvare) {
                <div class="fileinput">
                  <button class="logo-action-btn logo-action-btn--upload" mat-flat-button>
                    <mat-icon>upload</mat-icon>
                    Carica logo
                  </button>
                  <input
                    #fileInput
                    [disabled]="this.isPermessoSoloRead"
                    type="file"
                    name="fileDaCaricare"
                    (change)="fileSelezionato($any($event.target)?.files)"
                    (click)="$any($event.target).value = null"
                    accept="image/*"
                  />
                </div>
              }

              <p class="logo-hint">PNG, JPG fino a 1 MB</p>
            </div>
          </div>
        </div>

        <ng-container *ngIf="canSelectTipoInstallazione">
          <div
            class="separatore"
            appFormElement
            [larghezza]="4"
            [riempi]="true"
            *ngIf="!isModifica"
          >
            <div class="section-divider">
              <span class="section-divider__label">Tipo installazione</span>
            </div>
          </div>

          <mat-form-field appFormElement [larghezza]="3" [riempi]="true" *ngIf="!isModifica">
            <mat-label>Tipo installazione</mat-label>
            <mat-select
              [placeholder]="'Tipo installazione'"
              formControlName="tipoInstallazione"
              (selectionChange)="onSelectionChangeTipoInstallazione($event)"
            >
              <mat-option *ngFor="let tipo of listaTipiInstallazione" [value]="tipo.chiave">{{
                tipo.descrizione
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <div class="separatore" appFormElement [larghezza]="6" *ngIf="!isModifica">
          <div class="section-divider">
            <span class="section-divider__label">Referente</span>
          </div>
        </div>

        <mat-form-field appFormElement [larghezza]="3" [riempi]="true" *ngIf="!isModifica">
          <mat-label>Nome e Cognome</mat-label>
          <input matInput placeholder="Nome " formControlName="nome" />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="3" [riempi]="true" *ngIf="!isModifica">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" type="email" />
          <mat-error appFormError></mat-error>
        </mat-form-field>
      </form>
    </mat-step>

    <mat-step [completed]="true">
      <ng-template matStepLabel>Anagrafica Aziendale</ng-template>

      <form [formGroup]="formAzienda" appFormContainer [larghezza]="6" style="padding-right: 10px">
        <app-autocomplete
          appFormElement
          [larghezza]="3"
          [riempi]="true"
          formControlName="regione"
          [label]="'Regione'"
          [loadDataFn]="getRegioni"
          [displayFn]="displayFn"
          [compare]="compareLocalita"
          (recordChange)="getProvinciaAutoComplete($event)"
          [chiaveId]="'id'"
          [numeroRecOptions]="30"
        >
        </app-autocomplete>

        <app-autocomplete
          appFormElement
          [larghezza]="3"
          [riempi]="true"
          formControlName="provincia"
          [label]="'Provincia'"
          [loadDataFn]="getProvince"
          [displayFn]="displayFn"
          [compare]="compareLocalita"
          (recordChange)="getComuneAutoComplete($event)"
          [chiaveId]="'id'"
          [numeroRecOptions]="20"
        >
        </app-autocomplete>

        <app-autocomplete
          appFormElement
          [larghezza]="3"
          [riempi]="true"
          formControlName="comune"
          [label]="'Comune'"
          [loadDataFn]="getComune"
          [displayFn]="displayFn"
          [compare]="compareLocalita"
          [chiaveId]="'id'"
        >
        </app-autocomplete>

        <mat-form-field appFormElement [larghezza]="1">
          <mat-label>C.A.P</mat-label>
          <input matInput placeholder="C.A.P" formControlName="cap" minlength="5" maxlength="5" />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
          <mat-label>Indirizzo</mat-label>
          <input matInput placeholder="Indirizzo" formControlName="indirizzo" />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
          <mat-label>Sito Web</mat-label>
          <input matInput placeholder="Sito Web" formControlName="sitoWeb" />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="2">
          <mat-label>Fatturato</mat-label>
          <input
            matInput
            placeholder="Euro"
            formControlName="fatturato"
            type="number"
            appInputNumber
            inputmode="numeric"
            min="0"
            max="999999999999"
            (keydown)="onKeyDown($event)"
          />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
          <mat-label>Dipendenti</mat-label>
          <input
            matInput
            placeholder="Numero di dipendenti"
            formControlName="dipendenti"
            type="number"
            appInputNumber
            inputmode="numeric"
            min="0"
            (keydown)="onKeyDownDip($event)"
          />
          <mat-error appFormError></mat-error>
        </mat-form-field>

        <mat-form-field appFormElement [larghezza]="6">
          <mat-label>Descrizione</mat-label>
          <textarea matInput placeholder="Descrizione" formControlName="descrizione"></textarea>
          <mat-error appFormError></mat-error>
        </mat-form-field>
      </form>
    </mat-step>

    @if (canReadVSME) {
      <mat-step [completed]="true">
        <ng-template matStepLabel>VSME</ng-template>

        <app-info-form-vsme
          #infoFormVsme
          [infoFormVsme]="infoFormVsmeFromAzienda"
          [idAzienda]="this.formAzienda.get('id')?.value"
        ></app-info-form-vsme>
      </mat-step>
    }
  </mat-stepper>
</div>
@if (stepper.selectedIndex === 2) {
  <div style="height: 15px"></div>
}
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button
      *ngIf="!this.isPermessoSoloRead"
      mat-flat-button
      color="primary"
      class="primary-button"
      (click)="salvaAzienda()"
    >
      Salva
    </button>
  </div>
</div>
